import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50d76768"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EngineeringDetail" }
const _hoisted_2 = { class: "peoductInfo" }
const _hoisted_3 = { class: "infoItem" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "项目名称", -1))
const _hoisted_5 = { class: "value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoItem" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "采购单位"),
  /*#__PURE__*/_createElementVNode("div", { class: "value" }, "更多说明")
], -1))
const _hoisted_7 = { class: "infoItem" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "用苗地址", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "infoItem" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "发布时间", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "infoItem" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "截至时间", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "infoItem" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "报价方式", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "infoItem" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "发票类型", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "infoItem" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "订单状态", -1))
const _hoisted_24 = { class: "infoItem" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "其他说明", -1))
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "statistics" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("该采购品种：")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 种")
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("目前报价：")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 条")
const _hoisted_34 = { class: "filter" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "品种筛选", -1))
const _hoisted_36 = { class: "listItem" }
const _hoisted_37 = { class: "titleWarpper" }
const _hoisted_38 = { class: "title" }
const _hoisted_39 = { class: "tips" }
const _hoisted_40 = { class: "bottomAction" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time" }, "暂无报价", -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode("去报价")
const _hoisted_43 = { class: "actions" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("电话联系")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_46 = { class: "telNum" }
const _hoisted_47 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString($setup.detail.title), 1)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString($setup.detail.receiptAddress), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.detail.createTime), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString($setup.detail.expires), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, _toDisplayString($setup.detail.payTerm === 1 ? '上车价' : '到货价'), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, _toDisplayString($setup.detail.invoiceType === 1 ? '增值税发票' : '普通发票'), 1)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", {
          class: "value",
          style: _normalizeStyle({color:$setup.detail.approvalStatus === 1 ? '#FE8A0E' : $setup.detail.approvalStatus === 2 ? '#666666' : '#22C993'})
        }, _toDisplayString($setup.detail.approvalStatus === 1 ? '待审核' : $setup.detail.approvalStatus === 2 ? '审核拒绝' : '审核通过'), 5)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, _toDisplayString($setup.detail.profile), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("span", null, _toDisplayString($setup.category.length), 1),
        _hoisted_30
      ]),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("span", null, _toDisplayString($setup.detail.quotations), 1),
        _hoisted_33
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _hoisted_35,
      _createElementVNode("div", {
        class: _normalizeClass(["tags", $setup.classes])
      }, [
        _createVNode(_component_VanTag, {
          class: "all",
          size: "large",
          plain: "",
          color: "#FFCC32",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isShow = !$setup.isShow))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.isShow?'收起':'更多') + "标签", 1)
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.category, (item) => {
          return (_openBlock(), _createBlock(_component_VanTag, {
            class: "tag",
            size: "large",
            color: "#FFCC32",
            onClick: ($event: any) => ($setup.setCategory(item.key)),
            plain: item.key == $setup.getListData.categoryId
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.value), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "plain"]))
        }), 256))
      ], 2)
    ]),
    _createVNode(_component_VanList, {
      class: "list",
      listLoading: $setup.listLoading,
      "onUpdate:listLoading": _cache[1] || (_cache[1] = ($event: any) => (($setup.listLoading) = $event)),
      onLoad: $setup.getList,
      "immediate-check": false,
      finished: $setup.finished,
      "finished-text": "没有更多了"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createTextVNode(_toDisplayString(item.title) + " ", 1),
                _createElementVNode("span", null, "(" + _toDisplayString(item.quantity) + _toDisplayString(item.unit) + ")", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_39, _toDisplayString(item.specifications.join(',')), 1),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createVNode(_component_VanButton, {
                size: "mini",
                color: "#FFCC32",
                onClick: ($event: any) => ($setup.push({name:"QuotedPrice",query:{id:_ctx.$route.query.id,orderId:item.id,type:"engineer"}}))
              }, {
                default: _withCtx(() => [
                  _hoisted_42
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 256))
      ]),
      _: 1
    }, 8, ["listLoading", "finished"]),
    _createElementVNode("div", _hoisted_43, [
      _createVNode(_component_VanButton, {
        block: "",
        color: "#FEC64B",
        onClick: $setup.getTel
      }, {
        default: _withCtx(() => [
          _hoisted_44
        ]),
        _: 1
      })
    ]),
    _createVNode($setup["RestrictDialog"], {
      modelValue: $setup.restrictShow,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.restrictShow) = $event)),
      code: $setup.restrictCode,
      type: "cooperate"
    }, null, 8, ["modelValue", "code"]),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, "是否拨打 " + _toDisplayString($setup.tel), 1),
        _createElementVNode("a", {
          class: "call",
          href: `tel:${$setup.tel}`
        }, "立即呼叫", 8, _hoisted_47)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}